/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100NotFoundException } from './Ptw100NotFoundException';
import {
    Ptw100NotFoundExceptionFromJSON,
    Ptw100NotFoundExceptionFromJSONTyped,
    Ptw100NotFoundExceptionToJSON,
} from './Ptw100NotFoundException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100NotFoundException
 */
export interface ErrorResponseOfPtw100NotFoundException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100NotFoundException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100NotFoundException}
     * @memberof ErrorResponseOfPtw100NotFoundException
     */
    exception: Ptw100NotFoundException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100NotFoundException
     */
    $type?: ErrorResponseOfPtw100NotFoundExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100NotFoundExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100NotFoundExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100NotFoundException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100NotFoundExceptionTypeEnum = typeof ErrorResponseOfPtw100NotFoundExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100NotFoundExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100NotFoundException interface.
 */
export function instanceOfErrorResponseOfPtw100NotFoundException(value?: unknown): value is ErrorResponseOfPtw100NotFoundException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100NotFoundExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100NotFoundExceptionFromJSON(json: any): ErrorResponseOfPtw100NotFoundException {
    return ErrorResponseOfPtw100NotFoundExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100NotFoundExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100NotFoundException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100NotFoundExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100NotFoundExceptionToJSON(value?: Omit<ErrorResponseOfPtw100NotFoundException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100NotFoundExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

